import React, { useContext } from "react";

import { useIsTablet, useIsLargeScreen } from "../../lib/hooks/mediaQueries";

import { Grid } from "../../components/Grid/Grid";
import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import { Tagline } from "../../components/Tagline/Tagline";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import GeneralPageContext from "../../templates/GeneralPageContext";
import ElementContext from "../../components/ElementContext";

import * as styles from "./heroTextReduced.module.less";

function HeroTextReduced({
    data: { semanticOfHeadline, tagline, subheadline, headline, background },
    type,
    children,
    className
}) {
    const isMobile = useIsTablet();
    const isNotMobile = useIsLargeScreen();
    const gridSizeValue = isMobile ? "M" : isNotMobile ? "R" : "M";
    const { isLightBg } = useContext(ElementContext);

    const headlineClass = subheadline
        ? styles.headlineWithSubheadline
        : styles.headlineWithoutSubheadline;

    const {
        // showBreadcrumb === true when
        layout: { showBreadcrumb }
    } = useContext(GeneralPageContext);

    return (
        <SectionContainer
            sectionClass={gcs(className, styles.heroTextReducedSection, [
                showBreadcrumb,
                styles.breadcrumbPadding
            ])}
            containerClass={styles.heroTextReducedContainer}
            reducedWidth="never"
            background={background}
        >
            <div className={styles.heroTextReducedContent}>
                <div>
                    {tagline && (
                        <Tagline
                            hasLightBackground={isLightBg}
                            taglineClass={styles.heroTextReducedTagline}
                        >
                            {tagline}
                        </Tagline>
                    )}
                    {headline && (
                        <Headline
                            semanticOfHeadline={semanticOfHeadline}
                            hasLightBackground={isLightBg}
                            headlineClass={headlineClass}
                        >
                            {headline}
                        </Headline>
                    )}
                    <StructuredTextRenderer
                        data={subheadline}
                        contentElementType={type}
                    />

                    {children}
                </div>
                <div className={styles.heroTextReducedGridBlock}>
                    <Grid
                        className={styles.heroTextReducedGrid}
                        size={gridSizeValue}
                    />
                </div>
            </div>
        </SectionContainer>
    );
}

export { HeroTextReduced };
